import { nanoid } from 'nanoid'
import React from 'react'
import { checkTextTranslation, checkTranslation, translate } from '../../utils/useful'


class MultipleChoiceInput extends React.Component {
    state = {
        choiceOption: [
            {}
        ],
        firtRow: { title: '', value: nanoid() }
    }


    componentDidMount(){
        if(!this.props.data || this.props.data.length == 0){
            this.addHandler()
        }
    }

    changeInputValue(value) {
        this.props.changeValue(this.props.header.key, value, this.props.extra)

    }

    addHandler = () => {
        let data = this.props.data??[]
        data.push({ title: '', value: nanoid() })
        this.changeInputValue(data)
    }


    removeHandler = (index) => {
        let data = this.props.data
        let indexx = index
        // let y=data.index[indexx]
        console.log('eeeeeeee', index);
        if (data.length < 2) {
            alert('nooooo')
        } else {
            data.splice(index, 1)

        }
    }

    changeRowValue = (value, index) => {

        let data = this.props.data

        if (!Array.isArray(data)) {
            data = [{}]
        }
        console.log(value)
        data[index].title = value

        console.log(data)
        this.changeInputValue(data)
    }




    render() {


        let list = Array.isArray(this.props.data) ? this.props.data : [this.state.firtRow]

        return (
            <>
                {Array.isArray(list) && list.map((item, index) => {
                    return (
                        <div className="w-100 h-100 flexc">
                            <div className="flexcb mt-1" style={{ gap: ".2em" }}>
                                <div className="">
                                    <input type="checkbox" />
                                </div>
                                <div className='py-1 px-2' style={{ backgroundColor: "#f6f7f9", borderRadius: "5px" }}>
                                    <input disabled={this.props.header.information.disabled} autoFocus={this.props.header.information.autoFocus} ref={el => this.input = el} type="multiplechoice" step="any" value={item.title != null ? checkTranslation(item.title) : ''} maxLength={this.props.header.information.maxLength} onChange={(e) => this.changeRowValue(e.target.value, index)} placeholder={checkTextTranslation(this.props.header.information.placeholder ?? '{{lang}}Option ...')} className="transpanet-input" />
                                </div>
                                <div className="d-flex" style={{ gap: ".1em" }}>
                                    <img src="/images/remove-2.png" width={16} onClick={() => this.removeHandler(index)} alt="" />
                                    {/* <img src="/images/plus.png" width={16} onClick={() => this.addHandler()} alt="" /> */}

                                </div>


                            </div>
                        </div>
                    )
                })}

                <button className='mt-2' onClick={() => this.addHandler()}>
                    <p className='text-smaller' style={{ color: '#007aff' }}>+ {translate("Add Option")}</p>
                </button>

            </>
        );
    }
}

export default MultipleChoiceInput;